import { z } from "zod";

export const SchemaLandingForm = z.object({
  whatsapp: z.string({
    required_error: "Whatsapp diperlukan agar dapat menghubungi Anda nantinya.",
  }),
  message: z.string({ required_error: "Pesan wajib diisi" }),
  budget: z.enum(
    [
      "100-200",
      "200-300",
      "300-400",
      "400-500",
      "500-600",
      "600-700",
      "700-800",
      "800-900",
      "900-1m",
      "1m_keatas",
    ],
    {
      required_error: "Budget wajib dipilih",
    }
  ),
  timeline: z.enum(
    ["dalam_bulan_ini", "2_bulan_ini", "3_bulan_ini", "belum_tahu"],
    {
      required_error: "Rencana waktu pembangunan wajib dipilih",
    }
  ),
});
